import { GET_WELCOMEFLOW_API , GET_WELCOMEFLOW_API_SUCCESS , GET_WELCOMEFLOW_API_FAILURE, TRIGGER_TOAST } from "../constants";
import axios from "axios";


const welcomeFlowRegUpdate = (uId : number) => {
 return async (dispatch: any) => {
  dispatch({type: GET_WELCOMEFLOW_API});
  const data = await axios
      .post(`${process.env.REACT_APP_PROGRESS_URL}/api/WelcomeApi/IsWelcomeFlowUpdate?userId=${uId}`)
      .then((welcomeFlowUpdateData : any) => {
        if(welcomeFlowUpdateData && welcomeFlowUpdateData.data){
            dispatch({type: GET_WELCOMEFLOW_API_SUCCESS, payload: welcomeFlowUpdateData});
        }else{
            dispatch({type: GET_WELCOMEFLOW_API_FAILURE});
            dispatch({
                type: TRIGGER_TOAST,
                payload: {
                  shouldShow: true,
                  severity : 'error',
                  transMessage: "message_errorDefault"
                },
              });
        }
      })
      .catch(()=>{
        dispatch({ type: GET_WELCOMEFLOW_API_FAILURE });
        dispatch({
          type: TRIGGER_TOAST,
          payload: {
            shouldShow: true,
            severity : 'error',
            transMessage: "message_errorDefault"
          },
        });
      })
 }
}

export default {
    welcomeFlowRegUpdate,
}